export default "__VITE_ASSET__Cxx_GuZC__"